import { createSelector } from 'reselect';

const getDadata = state => state.Authorization.dadata.result;

export const selectDadata = createSelector([getDadata], items => {
  return items.map(org => {
    const { data } = org;
    return {
      key: `${org.value}, ${data.inn}`,
      name: `${org.value}`,
      inn: `${data.inn}`,
      kpp: `${data.kpp ? data.kpp : ''}`,
      ogrn: `${data.ogrn ? data.ogrn : ''}`,
      // ogrnip: `${org.ogrn.length === 15 ? org.ogrn : ''}`,
      // eio: `${org.fullName}`,
      dateRegistered: parseInt(`${data.state.registrationDate}`),
      address: `${data.address.value}`,
      isActing: `${data.state.status}`,
      opfShort: data.opf && data.opf.short,
    };
  });
});
